import React from "react";
import FondoServicios from "../images/Fondos/FondoServicios.jpg";

const ServiciosSection = () => {
  return (
    <section
      id="servicios"
      className="relative w-full py-12 md:py-24 lg:py-32 text-white overflow-hidden"
    >
      {/* Fondo con imagen y gradiente */}
      <div className="absolute inset-0 z-0">
        <img
          src={FondoServicios}
          alt="Fondo Tractor y Camion"
          className="object-cover w-full h-full"
        />
        <div 
          className="absolute inset-0"
          style={{
            background: `
              linear-gradient(90deg, rgba(20, 24, 54, 0.95) 0%, rgba(20, 24, 54, 0.2) 47%, rgba(20, 24, 54, 0) 49.8%, rgba(20, 24, 54, 0) 50.2%, rgba(20, 24, 54, 0.2) 53%, rgba(20, 24, 54, 0.95) 100%)
            `
          }}
        />
      </div>

      {/* Versión Escritorio - Se oculta en móvil */}
      <div className="hidden md:block container relative z-10 mx-auto px-4 md:px-6">
        <h2 className="text-2xl font-bold mb-16">
          SERVICIOS:
        </h2>
        
        <div className="grid grid-cols-3 gap-8">
          {/* Columna izquierda */}
          <div className="space-y-16">           <div>
              <h3 className="text-xl font-bold mb-2">• Canje de Cereal por Flete</h3>
              <p className="text-base">
                Hacé rendir tus granos
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">• Transporte Especializado</h3>
              <p className="text-base">
                Flota de vehículos adaptados para el transporte seguro para todo tipo de cargas.
              </p>
            </div>
          </div>

          {/* Columna central - vacía para espacio */}
          <div></div>

          {/* Columna derecha */}
          <div className="space-y-16 text-right">
            <div>
              <h3 className="text-xl font-bold mb-2">Seguridad •</h3>
              <p className="text-base">
                Protegemos tu carga con un seguro flotante.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Transportistas •</h3>
              <p className="text-base">
                Les ofrecemos el servicio de combustible en diferentes zonas del país.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Versión Móvil - Se oculta en escritorio */}
      <div className="md:hidden container relative z-10 mx-auto px-4">
        <h2 className="text-2xl font-bold mb-8 text-center">
          SERVICIOS:
        </h2>
        
        <div className="space-y-8">
        <div>
            <h3 className="text-lg font-bold mb-2">• Canje de Cereal por Flete</h3>
            <p className="text-sm">
              Hacé rendir tus granos
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-2">• Transporte Especializado</h3>
            <p className="text-sm">
              Flota de vehículos adaptados para el transporte seguro para todo tipo de cargas.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-2">• Seguridad</h3>
            <p className="text-sm">
              Protegemos tu carga con un seguro flotante.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-2">• Transportistas</h3>
            <p className="text-sm">
              Les ofrecemos el servicio de combustible en diferentes zonas del país.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiciosSection;
